class LqdImageComparisonHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initImageComparison();

  }

  getDefaultSettings() {
    return {
      selectors: {
        imageComparisonElement: '.cd-image-container',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $imageComparisonElement: this.$element.find(selectors.imageComparisonElement),
    }
  }

  initImageComparison() {

    this.elements.$imageComparisonElement.liquidImageComparison();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdImageComparisonHandler, { $element } );
};